import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { RoadKind, RoadKindSchema } from '../../RoadKind.enum'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Road,
  layer_id: EntityLayerId.TerrainL2,
  floor_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const RoadEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Road),
  layer_id: literal(EntityLayerId.TerrainL2),
  id: EntityIdSchema,
  road: RoadKindSchema,
  ...HasXYSchema.entries,
  floor_e: EntityElevationSchema,
})

export type RoadEntity = InferOutput<typeof RoadEntitySchema>

/**
 * Paved pathway designed for efficient ground unit movement, connecting key locations on the battlefield.
 */
export const RoadEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Road,
  dname: 'Road',
  layer_id: EntityLayerId.TerrainL2,
  group_id: EntityTypeGroupId.Terrain,
  defense: 0,
  entDefaults,
}

export function createRoadEntity(
  id: number,
  x: number,
  y: number,
  road: RoadKind
): RoadEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
    road,
  }
}
